import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ModulesProvider } from "@/context/ModulesContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Leads from "@/pages/Leads";
import Schedule from "@/pages/Schedule";
import Invoices from "@/pages/Invoices";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Estimates from "@/pages/Estimates";
import Catalog from "@/pages/Catalog";
import Dispatch from "@/pages/Dispatch";
import Inventory from "@/pages/Inventory";
import Expenses from "@/pages/Expenses";
import Payroll from "@/pages/Payroll";
import QuoteBuilder from "@/pages/QuoteBuilder";
import PublicQuote from "@/pages/PublicQuote";
import QualityChecks from "@/pages/QualityChecks";
import Capacity from "@/pages/Capacity";
import Mileage from "@/pages/Mileage";
import CAD from "@/pages/CAD";
import Equipment from "@/pages/Equipment";
import EquipmentDetail from "@/pages/EquipmentDetail";

const Protected = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ModulesProvider>
          <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/q/:token" element={<PublicQuote />} />
            <Route path="/cad" element={<CAD />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="leads" element={<Leads />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="estimates" element={<Estimates />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="dispatch" element={<Dispatch />} />
              <Route path="quality-checks" element={<QualityChecks />} />
              <Route path="capacity" element={<Capacity />} />
              <Route path="mileage" element={<Mileage />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="equipment" element={<Equipment />} />
              <Route path="equipment/:id" element={<EquipmentDetail />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="quotes" element={<QuoteBuilder />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ModulesProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
